import { useState, useContext, useEffect } from 'react';
import Context, { AccessContext } from '../components/context.js';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const Billing = () => {
    const access = useContext(AccessContext);
    const navigate = useNavigate();
    const setContext = useContext(Context)[1];
    
    // Set Page Title in Global Context
    useEffect(() => {
        setContext('Billing & Payouts');
    }, []);

    const [loading, setLoading] = useState(true);
    const [payoutMethods, setPayoutMethods] = useState([]);
    const [isRedirecting, setIsRedirecting] = useState(false);

    // 1. Load the list of existing payout methods (Bank Accounts/Cards)
    const loadPayoutInfo = () => {
        axios.post(process.env.REACT_APP_API_URL + 'payments/payouts/list')
            .then(r => {
                setLoading(false);
                if (r?.data?.data) {
                    setPayoutMethods(r.data.data);
                }
            })
            .catch(err => {
                setLoading(false);
                console.error("Error fetching payout methods", err);
            });
    }

    useEffect(() => {
        loadPayoutInfo();
    }, []);

    // 2. Trigger the Stripe Onboarding or Dashboard Login Link
    const handleStripeRedirect = () => {
        if (isRedirecting) return;
        setIsRedirecting(true);

        axios.post(process.env.REACT_APP_API_URL + 'payments/onboard')
            .then(r => {
                if (r?.data?.url) {
                    // Redirect the user to Stripe's secure hosted page
                    window.location.href = r.data.url;
                } else {
                    toast.error("Could not generate Stripe link.");
                    setIsRedirecting(false);
                }
            })
            .catch(err => {
                toast.error("Connection error. Please try again.");
                setIsRedirecting(false);
            });
    }

    if (loading) {
        return (
            <div className="loading mt-50" style={{ color: '#AAA5BF' }}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        )
    }

    return (
        <main>
            <div className="container w-100">
                <div className="form speaker-form f-col gap-20">
                    
                    {/* Section 1: Payout Methods Status */}
                    <div className="w-100 b-radius-4 b-1 p-20 bg-white">
                        <div className="f-row f-between f-center mb-20">
                            <div>
                                <h3 className="mb-5">Payout Methods</h3>
                                <p className="text-muted">Manage where you receive your donations and merch revenue.</p>
                            </div>
                            <button 
                                className="btn btn-blue" 
                                onClick={handleStripeRedirect}
                                disabled={isRedirecting}
                            >
                                {isRedirecting ? 'Connecting...' : 'Manage'}
                            </button>
                        </div>

                        <div className="w-100">
                            {payoutMethods.length > 0 ? (
                                <div className="card-container f-col gap-10">
                                    {payoutMethods.map((method, i) => (
                                        <div key={i} className="b-1 b-radius-4 p-15 f-row f-between f-center bg-f9">
                                            <div className="f-row f-center gap-15" style={{alignItems: 'center'}}>
                                                <div className="payout-icon">
                                                    {method.object === 'bank_account' ? '🏦' : '💳'}
                                                </div>
                                                <div class="payout-middle">
                                                    <div className="f-row f-center gap-10">
                                                        <span className="bold"><b>{method.bank_name || method.brand || 'Payout Method'}</b></span>
                                                        {method.default_for_currency && <span className="badge badge-green">Default</span>}
                                                    </div>
                                                    <span className="payout-4">•••• {method.last4}</span>
                                                </div>
                                            </div>
                                            <div className="payout-end">
                                                <span className={`status-pill ${method.status === 'new' || method.status === 'validated' ? 'active' : 'pending'}`}>
                                                    {method.status.toUpperCase()}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="b-1 b-radius-4 p-40 text-center dashed-border">
                                    <h4 className="mb-10">No Payout Methods Connected</h4>
                                    <p className="mb-20">You need to set up your Stripe Express account to start receiving payments.</p>
                                    <button className="btn btn-green" onClick={handleStripeRedirect}>
                                        Set Up Payouts Now
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Section 2: Informational Footer */}
                    <div className="w-100 b-radius-4 b-1 p-20 bg-white shadow-sm">
                        <h4 className="mb-10">About Payouts</h4>
                        <ul className="list-unstyled text-small line-height-1-5">
                            <li>Revenue from Merch and Donations are processed via Stripe.</li>
                            <li>Payouts are typically transferred to your bank account within 2-3 business days.</li>
                            <li>To change your tax information or personal details, use the "Manage" button above.</li>
                        </ul>
                    </div>

                </div>
            </div>
        </main>
    );
}

export default Billing;